<template>
    <BaseForm v-if="project">
        <template #fields>
            <MultiLink
                :label="$t('other-documents')"
                :links="values.otherDocuments"
                :error-messages="errors.otherDocuments"
                @input="setFieldValue('otherDocuments', $event)"
                @delete="setFieldValue('otherDocuments', $event)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import { useMultiLink } from '@/components/MultiLink/composables/useMultiLink';
import MultiLink from '@/components/MultiLink/MultiLink.vue';
import { useForm } from '@/forms/composables/useForm';
import { useProjectInjection } from '@/project/composables/useProjectInjection';
import { ProjectDocumentsSchema } from '@/project/schemas';
import { computed } from 'vue';

defineProps<{ projectId: string }>();

const { project, createProjectMultiLink } = useProjectInjection();
const { getFormFieldLinks, saveMultiLinkFields } = useMultiLink(createProjectMultiLink);

const otherDocumentsId = computed(() => project.value?.otherDocuments?.id);
const otherDocumentsLinks = computed(() => project.value?.otherDocuments?.links.nodes ?? []);

const { values, errors, setFieldValue, validate, onDiscard, resetForm } = useForm(
    ProjectDocumentsSchema,
    computed(() => ({
        otherDocuments: getFormFieldLinks(otherDocumentsLinks),
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await saveMultiLinkFields([
            { id: otherDocumentsId.value, fieldName: 'otherDocuments', links: values.value.otherDocuments },
        ]);
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
